import React from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";

const RichTextPreview = ({ title, text, updateOpenArrayState, sectionId }) => {
  const parse = require("html-react-parser");
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="mt-3 containerPreviewRichText">
      <p className="previewRichtextTitle">
        {parse(title.replaceAll(";;;", ""))}
      </p>
      <p className="previewRichtextText mt-3">
        {parse(text.replaceAll(";;;", ""))}
      </p>
      <div className="overlay4" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default RichTextPreview;
